module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-4.e7e647c0.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/radiance/radiance-4.png
// module id = 2687
// module chunks = 11